module.exports = __webpack_public_path__ + "static/img/fish27.37d30b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish27.png
// module id = ssea
// module chunks = 0